// @flow

/**
 * Module dependencies.
 */

import { en, pt } from 'client/translations/locales';
import { get } from 'lodash';
import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from 'config';
import i18n from 'i18next';

/**
 * `i18nextOptions`.
 */

const i18nextOptions = {
  cache: {
    enabled: true
  },
  fallbackLng: get(config, 'i18n.fallbackLng'),
  lng: get(config, 'i18n.defaultLng'),
  resources: { en, pt },
  whitelist: get(config, 'i18n.whitelist')
};

/**
 * Initialize i18n.
 */

i18n
  .use(Cache)
  .use(LanguageDetector)
  .init(i18nextOptions);

/**
 * Exports `i18n`.
 */

export default i18n;



// WEBPACK FOOTER //
// ../src/client/translations/i18n.js